import { createFileRoute } from '@tanstack/react-router';

import { AdminGeneralPage } from '@/features/organization-admin';

export const Route = createFileRoute('/admin/general')({
  component: AdminGeneralPage,
});
